// extracted by mini-css-extract-plugin
module.exports = {"bg":"_2hA5k","inlineContent":"_1fbSB","pageWrapper":"_2n0CE","root":"_2z65I"};